import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router'
import { useAuthUser } from 'contexts/AuthUserProvider'
import { homeURL, loginURL } from './urls'
import Lead from 'logic/Lead'
import { useAPI } from 'contexts/APIProvider'

const IsLeadUser: React.FC = ({ children }) => {
  const { authUser, logout } = useAuthUser()
  const { api } = useAPI()
  const location = useLocation()
  const params = useParams()
  const [lead, setLead] = React.useState<Lead | null>()  // undefined means not fetched yet, null means failed to fetch

  const leadId = React.useMemo(() => Number(params.leadId), [params.leadId])

  const fetchLead = React.useCallback(async () => {
    if (authUser) {
      try {
        setLead(await api.getLead(leadId))
      } catch (e: any) {
        console.error(e)
        setLead(null)
      }
    }
  }, [api, authUser, leadId])

  React.useEffect(() => {
    fetchLead()
  }, [fetchLead])

  if (authUser === undefined) {
    return null
  } else if (authUser === null) {
    return <Navigate replace to={loginURL(location.pathname)} />
  } else if (lead === undefined) {
    return null
  } else if (lead) {  // can access lead if it is not null or undefined
    return <React.Fragment>{children}</React.Fragment>
  } else {
    const redirectURL = homeURL(authUser)
    if (redirectURL) {
      return <Navigate replace to={redirectURL} />
    } else {
      logout()
      return <Navigate replace to={loginURL()} />
    }
  }
}

export default IsLeadUser